import { render, staticRenderFns } from "./verEditarModalInet.vue?vue&type=template&id=0e08734f&"
import script from "./verEditarModalInet.vue?vue&type=script&lang=ts&"
export * from "./verEditarModalInet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports